import { get } from './indexedDB';

export const getLocalData = async (key) => {
  try {
    const localData = await get(key);
    return localData;
  } catch (error) {
    console.error(`Could not get data from key ${key}`);
    return null;
  }
};
